// This icon file is generated automatically.
var PCaretLeftOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M8.77.58L2.82 5.71a.4.4 0 000 .58l5.95 5.13c.22.2.54.02.54-.29V.87c0-.3-.32-.48-.54-.29z", "fill-rule": "nonzero" } }] }, "name": "p-caret-left", "theme": "outlined" };
export default PCaretLeftOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PCaretLeftOutlined.js
// module id = 3266
// module chunks = 0